/* eslint-disable no-unused-vars */
import store from '@/store';
import { getNodeParentId, getAllModelProperties, scrollToElementInContainer } from './../../utils/forgeUtils';
import { log as debugLog } from '@/utils/debugLogger';

export const ModelBrowser = {
    state: {
        modelElementsObject: {},
        allModelItems: [],
        allProperties: [],
        allPropertiesByCategory: {},
        leafIds: [],
        treeIds: [],
        validNodes: [],
        selectedNode: null,
        selectedHarvesterNode: null,
        harvesterSelectedCategories: ['available-tag', 'filtered-tag', 'created-tag', 'ignored-tag']
    },
    mutations: {
        setModelElementsObject: (state, value) => {
            state.modelElementsObject = value;
        },
        setAllModelItems: (state, value) => {
            state.allModelItems = value;
        },
        setAllProperties : (state, value) => {
            state.allProperties = value;
        },
        setAllPropertiesByCategory : (state, value) => {
            state.allPropertiesByCategory = value;
        },
        setLeafIds: (state, value) => { 
            state.leafIds = value;
        },
        setTreeIds: (state, value) => {
            state.treeIds = value;
        },
        setSelectedNode: (state, value) => {
            if (state.selectedNode) {
                state.selectedNode.details = [];
                state.selectedNode.isSelected = false;             
            }

            if (value) value.isSelected = true;

            state.selectedNode = value;
        },
        SET_HARVESTER_VALID_NODE: (state, value) => {
            state.validNodes = value;
        },
        SET_HARVESTER_NODE: (state, value) => {
            state.selectedHarvesterNode = value;
        },
        SET_HARVESTER_CATEGORIES: (state, value) => {
            state.harvesterSelectedCategories = value;
        }
    },
    actions: {
        fillAllModelProperties ({ dispatch, commit, state }, { viewer, callBack }) {
            if (state.allProperties?.length) {
                if (callBack) setTimeout(callBack, 0);
                return;
            }

            getAllModelProperties(viewer, ({ properties, categories }) => {
                state.allProperties = properties;
                state.allPropertiesByCategory = categories;                
                debugLog(`✅ Loading All Model Properties`)
                if (callBack) setTimeout(callBack, 0);
            })
        },
        pushToAllModelItems ({ dispatch, commit, state }, { value }) {
            state.allModelItems = [...state.allModelItems, value];
        },
        pushToAllProperties ({ dispatch, commit, state }, { value }) {
            state.allProperties = [...state.allProperties, value];
        },
        pushToTreeIds: ({ dispatch, commit, state }, { value }) => { 
            state.treeIds = [...state.treeIds, value];
        },
        updateSelectedNode: ({ dispatch, commit, state }, { nodeId }) => {
            let update = () => {
                let node = state.allModelItems.find((node) => node.nodeId == nodeId);
    
                if (state.selectedNode) {
                    state.selectedNode.details = [];
                    state.selectedNode.isSelected = false;
                }
    
                if (!node) return;

                node.isSelected = true;
    
                node.makeAllParentVisible();
    
                if (!node.isHighlighted) {
                    setTimeout(() => {
                        const element = document.getElementById(`node${node.nodeId}`);
                        scrollToElementInContainer(element, ".nodes__container.scollable-container");
                    }, 50);
                }

                commit('setSelectedNode', node);
            }
            
            if (nodeId) {
                if (!state.allModelItems.some(n => n.nodeId == nodeId)) {
                    dispatch('getAllParents', { nodeId: nodeId }).then(parents => {
                        parents = parents.reverse();

                        if (parents) {
                            state.modelElementsObject?.checkToLeaf(parents, nodeId);
                        }

                        update();
                    })

                } else {
                    update();
                }
            } else {
                commit('setSelectedNode', null);
            }

        },
        getAllParents: ({ dispatch, commit, state }, { nodeId }) => {
            return dispatch('getTreeIdsFromLeaf', { dbIds: [nodeId] }).then( () => {
                let parents = [...state.treeIds];
        
                parents = parents.filter(p => p != 1);
        
                commit('setTreeIds', []);
                commit('setLeafIds', []);
        
                return parents;
            })
            
        },
        getNodeParent: ({ dispatch, commit, state }, { id }) => {
            let parentId = getNodeParentId(store.state.viewer, id);

            if (!state.treeIds.includes(parentId)) {
                if (parentId != 0) {
                    dispatch('pushToTreeIds', { value: parentId });
                    dispatch('getNodeParent', { id: parentId });
                }
            }
        },
        getTreeIdsFromLeaf: ({ dispatch, commit, state }, { dbIds }) => {
            commit('setTreeIds', [...dbIds]);
            commit('setLeafIds', [...dbIds]);
            dbIds.forEach(id => {
                dispatch('getNodeParent', { id: id });
            });
        }
    },
    getters: {
        getModelElementsObject: (state) => {
            return state.modelElementsObject;
        },
        getAllModelItems: (state) => {
            return state.allModelItems;
        },
        getAllProperties : (state) => {
            return state.allProperties;
        },
        getAllPropertiesByCategory : (state) => {
            return state.allPropertiesByCategory;
        },
        getLeafIds: (state) => {
            return state.leafIds;
        },
        getTreeIds: (state) => {
            return state.treeIds;
        },
        getSelectedNode: (state) => {
            return state.selectedNode;
        },
        GET_HARVESTER_VALID_NODE: (state) => {
            return state.validNodes;
        },
        GET_HARVESTER_NODE: (state) => {
            return state.selectedHarvesterNode;
        },
        GET_HARVESTER_CATEGORIES: (state) => {
            return state.harvesterSelectedCategories;
        }
    },
}